/*

Some context:
We are deleting users' local storage and resetting their StoreCookie if we identify that they had previously
been assigned to Sterling, VA.  To prevent us from an infinite loop of deleting, we need to keep track of 
whether the user has already had their local storage and cookie deleted.  

To complicate matters a bit, we originally used 'true' to indicate whether someone has had their cache cleared,
but when subsequent clearings were required, we switched from 'true' to a fixNumber (which is actually stored as 
a	string).

*/

const shouldDeleteLocalStorage = (
    storeDeletedValue: string | null,
    fixNumber: number
): boolean => {
    // This catches users who have never had their local storage cleared
    if (storeDeletedValue === null) {
        return true;
    }

    /*
		This catches two types of users 
		1. previously given "true" because they had their local storage cleared when we were using "true" as the flag
		2. previously given a fixNumber string (like "1") because they had their local storage cleared when we were using the fixNumber approach		
		*/

    return (
        storeDeletedValue === 'true' || Number(storeDeletedValue) < fixNumber
    );
};

export { shouldDeleteLocalStorage };
